import React from 'react'
import { Stack } from '@mui/material'

export const TargetSummary = ({ targetSummary = [] }) => {
  return (
    <>
      <Stack spacing={0.75} sx={{ my: 0.25, minWidth: 220 }}>
        {targetSummary.map(({ product, earned, target, variance }) => (
          <span key={product} style={{ color: variance < 0 ? 'red' : 'green' }}>
            {product}: {earned} (Target: {target})
          </span>
        ))}
      </Stack>
    </>
  )
}
